// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PrintIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PrintIcon" ref={forwardedRef} {...props}>
      <path d="M14 10.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M5 2.25v4H3.75A1.75 1.75 0 0 0 2 8v7.75h3V18h10v-2.25h3V8a1.75 1.75 0 0 0-1.75-1.75H15v-4zm8.5 4h-7v-2.5h7zm-8.5 8H3.5V8a.25.25 0 0 1 .25-.25h12.5A.25.25 0 0 1 16.5 8v6.25H15v-2.5H5zm1.5-1h7v3.25h-7z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const PrintIcon = /* @__PURE__ */ Object.assign(PrintIconComponent, {
  displayName: 'PrintIcon',
});
